import OverlayRenderer from './overlay-renderer';
import ResourceLoader from '../resource-loader';

//LAZY import {fabric} from 'fabric';
//LAZY import QRCode from 'easyqrcodejs';

import * as log from 'loglevel';
import RenderUtil from './render-util';

class QrcodeRenderer extends OverlayRenderer {

    _getImage(layer, context, canvas, params = layer.params) {

        // text default stored in params
        let text = params.text || '';

        // fontFamily reference from font option
        if (params.option) {
            let productOption = RenderUtil.getProductOption(params.option, context.options);

            if (productOption) {
                if (productOption.value) {
                    // update content
                    text = productOption.value;
                }
            }
        }

        if (text) {

            let level = log.getLevel();

            if (level <= log.levels.DEBUG) {
                console.time('====> QR RENDER');
            }

            // only use cached if text has not changed
            if (layer._object && layer._qrText === text) {

                if (level <= log.levels.DEBUG) {
                    console.timeEnd('====> QR RENDER');
                }

                return Promise.resolve(layer._object);
            } else {

                // resources loaded async
                let resources = [
                    context.assets + '/static/lib/easyqrcodejs/easy.qrcode.min.js'
                ];

                // load resources if not already ( this.ready can be checked from outside with a promise.then )
                let ready = ResourceLoader.loadOnce(resources, 'qrcode',  {async: false /* fetch parallel - load in series */ });

                // return the ready promise (only completes after rendering)
                return ready.then(() => {

                    return new Promise((resolve, reject) => {

                        let renderComplete = (options, dataUrl) => {

                            if (level <= log.levels.DEBUG) {
                                console.timeEnd('====> QR RENDER');
                            }

                            fabric.Image.fromURL(dataUrl, (fabricImg) => {

                                if (fabricImg === undefined) {

                                    log.warn('qr image invalid');

                                    // still resolve and not reject to continue rendering
                                    resolve(null);
                                    return;
                                }

                                // store text to compare
                                layer._qrText = text;

                                resolve(fabricImg);
                            });

                        }

                        // in memory div to render qr canvas
                        if (!layer._qrDiv) {
                            layer._qrDiv = document.createElement('div');
                        }

                        // editorMode always create new instance (to support config changes)
                        if (context.editorMode && layer._qrCode) {
                            layer._qrCode.clear();
                            delete layer._qrCode;
                        }

                        // create instance only once
                        if (!layer._qrCode) {

                            // just render the qr code at half the preview width OR max 1000px
                            // object can then be scaled on fabric canvas
                            let size = Math.min(context.config.width / 2, 1000);

                            let options = {
                                text: text,
                                width: size,
                                height: size,
                                onRenderingEnd: renderComplete // callback when finished rendering
                            };

                            // url assets used as logo
                            if(params.url){
                                options.logo = params.url;
                                options.crossOrigin = 'anonymous'; // required to get base64 of qr canvas
                                // site left to automatic (to big of a size makes the qr code invalid)
                                // options.logoWidth: size / 5, // width. default is automatic width
                                // options.logoHeight: size / 5, // height. default is automatic height
                            }

                            layer._qrCode = new QRCode(layer._qrDiv, options);
                        } else {
                            // IMPORTANT: update internal options complete function to reference the current promise
                            layer._qrCode._htOption.onRenderingEnd = renderComplete;
                            layer._qrCode._oDrawing._htOption.onRenderingEnd = renderComplete;
                            // generate new code
                            layer._qrCode.makeCode(text);
                        }

                    });
                });

            }

        }

        return Promise.resolve(null);
    }
}

export default QrcodeRenderer;